import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Icon,
  Layout,
  Menu,
  Row,
  Select,
  Switch,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  notification,
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import _, { get } from 'lodash';
import { canAccess } from 'o2o_layout';
import { TypeTermOfOrg, UISetting } from 'o2o_layout/lib/common/model';
import { Methods } from 'o2o_layout/lib/common/rest';
import * as React from 'react';
import CommonTypeProps from '../../../common/CommonTypeProps';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import { TypeEDMSendInBlue } from '../../../redux/reducer/edmSendInBlueReducer';
import { typeCurrentUserOrgs } from '../../../redux/reducer/selectCurrentOrgReducer';
import { CommonNotificationSaveError, CommonNotificationUpdateSuccessfully } from '../../../shares/CommonNotification';
import { O2OFormItem } from '../../../shares/O2OFormItem';
import { CommonDAL } from '../../../shares/dal/CommonDAL';
import { typeUpdateOrg } from '../../orgs/OrgsAction';
import { typeUpdateAcount } from '../ConsoleUsersAction';
import { FormCompany, IndustriesList } from '../profile/FormMyCompany';
import { DrawerTerm } from './DrawerTerm';
import { FormPasswordPolicy } from './PassPolicy';
import { SessionPolicy } from './SessionPolicy';
import { UpdateStatusTerm } from './UpdateStatusTerm';
import CustomUI from './components/custom-ui';
import DataMaking from './components/data-making';
import Localization from './components/localization';
import { OrgAvatar } from './OrgAvatar';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
import { IconEdit, IconMail, IconPhone, IconPosition, IconWorld } from '@shares/DMPIcon';
import Require2FA from './components/require-2fa';
import { Authen } from '@redux/model';

interface Props extends CommonTypeProps, FormComponentProps {
  updateAccount: typeUpdateAcount;
  updateOrgByAdminClient: typeUpdateOrg;
  changePwd: any;
  edmSendInBlue: TypeEDMSendInBlue;
  updateEDMSendInBlue: any;
  getEDMSendInBlue: any;
  getCurrentUserOrgs: any;
  currentUserOrgs: typeCurrentUserOrgs;
  getMe: any;
  uiSetting: UISetting;
  authen: Authen;
}

export interface IGeneralSetting {
  allowedDomains: string[];
  invitationUsersToJoin: boolean;
}

export class UserCompany extends React.Component<Props, any> {
  formRef: any;
  formRefInfo: any;
  formRefEDM: any;
  formRefChangePassword: any;

  state = {
    activeTab: 'Information',
    confirmDirty: false,
    visibleCompany: false,
    visibleTerm: false,
    selectedMenu: 'info',
    loadingSave: false,
    loadingSaveClose: false,
    generalSetting: {} as IGeneralSetting,
    loading: false as boolean,
  };

  componentDidMount = () => {
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.Organization });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.Organization,
        title: BIGDATA_CONSTANT.trackTitle.Organization,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
    this.loadGeneralSetting();
  };
  timer: any;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  checkCurrentUserIsSuperAdmin = (): boolean => {
    if (this.props.user) {
      if (this.props.user.orgCtx) {
        let roles = this.props.user.orgCtx.roles;
        let isSP = _.find(roles, (e) => {
          return e == 'SUPER_ADMIN';
        });

        if (isSP) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };

  submitUpdateOrg = (e: any, type: string) => {
    e.preventDefault();
    const form = this.formRef.props.form;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      type === 'save' ? this.setState({ loadingSave: true }) : this.setState({ loadingSaveClose: true });
      // let isSAdmin = this.checkCurrentUserIsSuperAdmin()
      values.id = this.props.user.orgCtx ? this.props.user.orgCtx.orgId : null;
      this.props
        .updateOrgByAdminClient(values, false)
        .then(() => {
          if (this.props.commonResponse.success) {
            type === 'save' ? this.setState({ loadingSave: false }) : this.setState({ loadingSaveClose: false });
            notification.success({
              message: BIGDATA_CONSTANT.message.default.title.success,
              description: BIGDATA_CONSTANT.message.notification.success.update,
              icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
            });

            type === 'save-close' &&
              this.setState({
                visibleCompany: false,
              });
            type === 'save' ? this.setState({ loadingSave: false }) : this.setState({ loadingSaveClose: false });
            setTimeout(() => {
              // window.location.reload()
              this.props.getMe();
            }, 1000);
          } else {
            type === 'save' ? this.setState({ loadingSave: false }) : this.setState({ loadingSaveClose: false });
            type === 'save' && this.setState({ loadingSave: false });
            notification.error({
              message: BIGDATA_CONSTANT.message.default.title.error,
              description: this.props.commonResponse.message,
            });
          }
        })
        .catch((e: any) => {
          type === 'save' ? this.setState({ loadingSave: false }) : this.setState({ loadingSaveClose: false });
          notification.error({
            message: BIGDATA_CONSTANT.message.default.title.error,
            description: e.data.message,
          });
        });
    });
  };

  submitPwd = (e: any) => {
    e.preventDefault();
    this.formRefChangePassword.props.form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        this.props.setGlobalLoading(true);
        this.props.changePwd(values.current_password, values.password, values.confirm).then(() => {
          this.props.setGlobalLoading(false);
          this.formRefChangePassword.props.form.resetFields();
          notification.success({
            message: BIGDATA_CONSTANT.message.default.title.success,
            description: 'Change password successfuly',
            icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
          });
        });
      }
    });
  };

  submitUpdateInfo = (e: any) => {
    e.preventDefault();
    this.formRefInfo.props.form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        let user: any = Object.assign(values, {
          email: values.id,
          status: 'active',
        });

        let isSPA = this.checkCurrentUserIsSuperAdmin();
        let promise: any = this.props.updateAccount(user, isSPA);
        this.props.setGlobalLoading(true);
        promise
          .then(() => {
            if (this.props.commonResponse.success) {
              notification.success({
                message: BIGDATA_CONSTANT.message.default.title.success,
                description: `User ${this.props.user.id} updated successfully`,
                icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
              });

              this.props.setGlobalLoading(false);
            } else {
              notification.error({
                message: BIGDATA_CONSTANT.message.default.title.error,
                description: _.get(this.props.commonResponse, 'message', 'Something went wrong.'),
              });
            }
          })
          .catch(() => {
            this.props.setGlobalLoading(false);
          });
      }
    });
  };

  getTermOfOrg = () => {
    let { id } = this.props.user.orgCtx ? this.props.user.orgCtx.organization : { id: '' };
    let term: TypeTermOfOrg | undefined = this.props.currentUserOrgs.orgs.terms[id] || undefined;
    return term;
  };

  renderMoreSetting = () => {
    return (
      <Row type='flex' gutter={[5, 5]}>
        <Col xs={24}>
          <Typography.Title level={4}>General Setting</Typography.Title>
        </Col>
        <Col xs={24} lg={12}>
          <Card size='small'>
            <O2OFormItem
              label={
                <span>
                  Allowed Account Domains{' '}
                  <Tooltip
                    title={
                      <ul style={{ paddingLeft: 20, margin: 0 }}>
                        <li>List of account domains are able to to the organization</li>
                        <li>Turn off the restriction by setting empty list</li>
                      </ul>
                    }
                  >
                    <Icon type='question-circle' />
                  </Tooltip>
                </span>
              }
            >
              {this.props.form.getFieldDecorator('domains', {
                initialValue: this.state.generalSetting.allowedDomains,
              })(<Select style={{ width: '100%' }} showSearch showArrow placeholder='your-domain.com' mode={'tags'} />)}
            </O2OFormItem>

            <O2OFormItem
              label={
                <span>
                  Invite Users to Join Organization{' '}
                  <Tooltip title={'Turn on User Invitation to Join Organization'}>
                    <Icon type='question-circle' />
                  </Tooltip>
                </span>
              }
            >
              {this.props.form.getFieldDecorator('invitationUsersToJoin', {
                valuePropName: 'checked',
                initialValue: this.state.generalSetting.invitationUsersToJoin,
              })(<Switch checkedChildren='Enabled' unCheckedChildren='Disabled' />)}
            </O2OFormItem>

            <Button
              onClick={() => {
                this.props.form.validateFields(async (err: any, values: any) => {
                  if (!err) {
                    this.setState({
                      loading: true,
                    });
                    const result = this.props.commonActionFromDALV2(
                      CommonDAL.buildURL,
                      BIGDATA_CONSTANT.url.api + `mngmnt-client/orgs/config/general-settings/save`,
                      {
                        allowedDomains: values.domains,
                        invitationUsersToJoin: values.invitationUsersToJoin,
                      },
                      Methods.POST
                    );
                    try {
                      const response = await result;
                      if (response.success) {
                        setTimeout(() => {
                          this.loadGeneralSetting();
                        }, 1000);
                        CommonNotificationUpdateSuccessfully();
                      } else {
                        CommonNotificationSaveError(get(response, 'message'));
                      }
                      this.setState({
                        loading: false,
                      });
                    } catch (error) {
                      this.setState({
                        loading: false,
                      });
                      CommonNotificationSaveError(get(error, 'message'));
                    }
                  }
                });
              }}
              style={{ marginTop: 8 }}
              loading={this.state.loading}
              type='primary'
            >
              Save
            </Button>
          </Card>
        </Col>
      </Row>
    );
  };

  loadGeneralSetting = async () => {
    const result = this.props.commonActionFromDALV2(
      CommonDAL.buildURL,
      BIGDATA_CONSTANT.url.api + `mngmnt-client/orgs/config/general-settings/get`,
      {},
      Methods.GET
    );
    try {
      const response: any = await result;
      if (response.success) {
        this.setState({
          generalSetting: get(response, 'result', {}),
        });
      } else {
        this.setState({
          generalSetting: {},
        });
      }
    } catch (error) {
      this.setState({
        generalSetting: {},
      });
    }
  };

  renderContent = () => {
    if (this.state.selectedMenu === 'general-setting') {
      return this.renderMoreSetting();
    } else if (this.state.selectedMenu == 'info') {
      return this.renderInfoContent();
    } else if (this.state.selectedMenu == 'term') {
      return this.renderTermContent();
    } else if (this.state.selectedMenu == 'password') {
      return this.renderPolicyContent();
    } else if (this.state.selectedMenu == 'session') {
      return this.renderSessionPolicy();
    } else if (this.state.selectedMenu === 'custom-ui') {
      return this.renderCustomUI();
    } else if (this.state.selectedMenu === 'data-masking') {
      return this.renderDataMaking();
    } else if (this.state.selectedMenu === 'localization') {
      return this.renderLocalization();
    } else if (this.state.selectedMenu === 'require-2fa') {
      return this.renderRequire2FA();
    }

    return null;
  };

  renderSessionPolicy = () => {
    const userRoles = this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.roles : []) : [];
    return (
      <>
        {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
          <SessionPolicy
            visible={this.state.selectedMenu == 'session' ? true : false}
            commonActionFromDAL={this.props.commonActionFromDAL}
            onClose={() => {}}
            success={() => {}}
          />
        ) : null}
      </>
    );
  };

  renderPolicyContent = () => {
    const userRoles = this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.roles : []) : [];
    return (
      <>
        {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
          <FormPasswordPolicy
            visible={this.state.selectedMenu == 'password' ? true : false}
            commonActionFromDAL={this.props.commonActionFromDAL}
            onClose={() => {}}
            success={() => {}}
          />
        ) : null}
      </>
    );
  };

  renderCustomUI = () => {
    return <CustomUI commonActionFromDALV2={this.props.commonActionFromDALV2} />;
  };

  renderDataMaking = () => {
    return <DataMaking commonActionFromDALV2={this.props.commonActionFromDALV2} />;
  };

  renderLocalization = () => {
    return <Localization commonActionFromDALV2={this.props.commonActionFromDALV2} />;
  };

  renderRequire2FA = () => {
    return <Require2FA authen={this.props.authen} />;
  };

  renderType = (key: string) => {
    switch (key) {
      case 'Trial':
        return <Tag style={{ background: '#EB2C56', color: '#fff', borderColor: '#EB2C56' }}>{key}</Tag>;
      case 'Basic':
        return <Tag style={{ background: '#FCBC04', color: '#fff', borderColor: '#FCBC04' }}>{key}</Tag>;
      case 'Profesional':
        return <Tag style={{ background: '#38A456', color: '#fff', borderColor: '#38A456' }}>{key}</Tag>;
      case 'Enterprise':
        return <Tag style={{ background: '#9837FF', color: '#fff', borderColor: '#9837FF' }}>{key}</Tag>;
      case 'Contract':
        return <Tag style={{ background: '#47BBBD', color: '#fff', borderColor: '#47BBBD' }}>{key}</Tag>;
      default:
        return (
          <Tag style={{ background: '#fff', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>
            {key}
          </Tag>
        );
    }
  };

  renderInfoContent = () => {
    return (
      <Row type='flex' gutter={[45, 0]} className='mt30 ml5'>
        <Col>
          <OrgAvatar
            commonDALV2={this.props.commonActionFromDALV2}
            onSuccess={() => {
              this.props.getMe();
            }}
            org={this.props.user.orgCtx ? this.props.user.orgCtx.organization : undefined}
          />
        </Col>
        <Col xs={19}>
          <Row type='flex' gutter={[20, 20]} align='middle'>
            <Col xs={24}>
              <Typography.Title level={3} className='mb0'>
                {this.props.user.orgCtx ? this.props.user.orgCtx.organization.name : '--/--'}
                <Button
                  style={{
                    width: 'fit-content',
                    height: 'fit-content',
                    padding: 0,
                    margin: 0,
                  }}
                  type='link'
                  onClick={() => {
                    this.setState({
                      visibleCompany: true,
                    });
                  }}
                >
                  <Icon className='ml10' component={IconEdit} />
                </Button>
              </Typography.Title>
            </Col>

            <Col xs={24}>
              {this.renderType(
                this.props.user.orgCtx
                  ? _.get(IndustriesList, this.props.user.orgCtx.organization.accountType, 'Other')
                  : '--/--'
              )}
              <Tag style={{ background: '#fff', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>
                {this.props.user.orgCtx
                  ? _.get(IndustriesList, this.props.user.orgCtx.organization.industry, 'Other')
                  : '--/--'}
              </Tag>
            </Col>

            <Col xs={24} className='mt5'>
              <Row gutter={[15, 15]}>
                <Col xs={24}>
                  <Icon className='mr5' component={IconMail} />
                  {this.props.user.orgCtx ? this.props.user.orgCtx.organization.email || '--/--' : '--/--'}
                </Col>

                <Col xs={24}>
                  <Icon className='mr5' component={IconPhone} />
                  {this.props.user.orgCtx ? this.props.user.orgCtx.organization.phone || '--/--' : '--/--'}
                </Col>

                <Col xs={24}>
                  <Icon className='mr5' component={IconPosition} />
                  {this.props.user.orgCtx ? this.props.user.orgCtx.organization.address || '--/--' : '--/--'}
                </Col>

                <Col xs={24}>
                  <Icon className='mr5' component={IconWorld} />
                  {this.props.user.orgCtx ? this.props.user.orgCtx.organization.website || '--/--' : '--/--'}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  renderTermContent = () => {
    let term: TypeTermOfOrg | undefined = this.getTermOfOrg();
    const userRoles = this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.roles : []) : [];
    return (
      <Row gutter={[20, 20]}>
        <Button
          icon='edit'
          type='link'
          onClick={() => {
            this.setState({
              visibleCompany: true,
            });
          }}
          style={{
            position: 'absolute',
            right: 20,
            zIndex: 22,
          }}
        />

        <Col xs={24}>
          <Row type='flex' gutter={[20, 20]} align='middle'>
            {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
              <React.Fragment>
                <Col xs={24}>
                  <UpdateStatusTerm
                    term={term ? term.term : undefined}
                    success={() => {
                      this.props.getCurrentUserOrgs();
                    }}
                    commonActionFromDAL={this.props.commonActionFromDAL}
                    status={term ? term.active : false}
                  />
                </Col>
                <Col xs={24}>{this.renderTerm()}</Col>
              </React.Fragment>
            ) : null}
          </Row>
        </Col>
      </Row>
    );
  };

  renderDrawer = () => {
    return (
      <Drawer
        title='UPDATE INFORMATION'
        visible={this.state.visibleCompany}
        onClose={() =>
          this.setState(
            {
              visibleCompany: false,
            },
            () => {
              this.formRef.props.form.resetFields();
            }
          )
        }
        width={'600px'}
        bodyStyle={{ marginBottom: 80 }}
      >
        <FormCompany
          locale={this.props.locale}
          orgCtx={this.props.user.orgCtx}
          loading={this.props.ui.isLoading}
          wrappedComponentRef={(propsRef: any) => (this.formRef = propsRef)}
          submit={this.submitUpdateOrg}
          visibleCompany={this.state.visibleCompany}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }}
        >
          <Button
            style={{ marginRight: 5 }}
            onClick={() =>
              this.setState(
                {
                  visibleCompany: false,
                },
                () => {
                  this.formRef.props.form.resetFields();
                }
              )
            }
          >
            Discard
          </Button>
          <Button
            loading={this.state.loadingSave}
            style={{ marginRight: 5 }}
            onClick={(e) => {
              this.submitUpdateOrg(e, 'save');
            }}
            type='primary'
          >
            Save
          </Button>
          <Button
            loading={this.state.loadingSaveClose}
            onClick={(e) => {
              this.submitUpdateOrg(e, 'save-close');
            }}
            type='primary'
          >
            Save & Close
          </Button>
        </div>
      </Drawer>
    );
  };

  renderTerm = () => {
    return (
      <DrawerTerm
        onClose={() => {}}
        commonActionFromDAL={this.props.commonActionFromDAL}
        term={this.getTermOfOrg()}
        visible={this.state.visibleTerm}
        success={() => {
          this.props.getCurrentUserOrgs();
        }}
        user={this.props.user}
      />
    );
  };

  renderContentLayout = (version?: string) => {
    return version === 'v2' ? (
      <>
        <Tabs
          animated={false}
          onChange={(activeKey) => {
            if (activeKey === 'information') {
              this.setState({
                activeTab: 'Information',
              });
            }
            if (activeKey === 'security')
              this.setState({
                activeTab: 'Security',
                selectedMenu: 'password',
              });
            if (activeKey === 'settings')
              this.setState({
                activeTab: 'Settings',
                selectedMenu: 'custom-ui',
              });
          }}
        >
          <Tabs.TabPane tab='Information' key='information'>
            {this.renderInfoContent()}
          </Tabs.TabPane>
          <Tabs.TabPane tab='Security' key='security'>
            <Layout>
              <Layout.Sider width={200} theme='light' className='main-menu-v3 menu-connection'>
                <Menu
                  mode='inline'
                  selectedKeys={[this.state.selectedMenu]}
                  onClick={(e: any) => {
                    this.setState({
                      selectedMenu: e.key,
                    });
                  }}
                  style={{ height: '100%' }}
                >
                  <Menu.Item key='password'>Password Policy</Menu.Item>
                  <Menu.Item key='session'>Session Policy</Menu.Item>
                  <Menu.Item key='data-masking'>Data masking</Menu.Item>
                  <Menu.Item key='general-setting'>Allowed Domain</Menu.Item>
                  <Menu.Item key='require-2fa'>Require 2FA</Menu.Item>
                  <Menu.Item key='term'>Terms of Use</Menu.Item>
                </Menu>
              </Layout.Sider>
              <Layout.Content style={{ overflow: 'hidden' }} className='pl30 pt10'>
                {this.renderContent()}
              </Layout.Content>
            </Layout>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Settings' key='settings'>
            <Layout>
              <Layout.Sider width={200} theme='light' className='main-menu-v3 menu-connection'>
                <Menu
                  mode='inline'
                  selectedKeys={[this.state.selectedMenu]}
                  onClick={(e: any) => {
                    this.setState({
                      selectedMenu: e.key,
                    });
                  }}
                  style={{ height: '100%' }}
                >
                  <Menu.Item key='custom-ui'>Custom UI</Menu.Item>
                  <Menu.Item key='localization'>Localization</Menu.Item>
                </Menu>
              </Layout.Sider>
              <Layout.Content style={{ overflow: 'hidden' }} className='pl30 pt10'>
                {this.renderContent()}
              </Layout.Content>
            </Layout>
          </Tabs.TabPane>
        </Tabs>

        {this.renderDrawer()}
      </>
    ) : (
      <Layout>
        <Layout.Sider width={200} theme='light' style={{ marginRight: 30 }}>
          <Menu
            mode='inline'
            selectedKeys={[this.state.selectedMenu]}
            onClick={(e: any) => {
              this.setState({
                selectedMenu: e.key,
              });
            }}
            style={{ height: '100%' }}
          >
            <Menu.Item key='info'>Information</Menu.Item>
            <Menu.SubMenu title='Security'>
              <Menu.Item key='password'>Password Policy</Menu.Item>
              <Menu.Item key='session'>Session Policy</Menu.Item>
              <Menu.Item key='data-masking'>Data masking</Menu.Item>
              <Menu.Item key='general-setting'>Allowed Domain</Menu.Item>
              <Menu.Item key='require-2fa'>Require 2FA</Menu.Item>
              <Menu.Item key='term'>Terms of Use</Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu title='More Settings'>
              <Menu.Item key='custom-ui'>Custom UI</Menu.Item>
              <Menu.Item key='localization'>Localization</Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </Layout.Sider>
        <Layout.Content style={{ overflow: 'hidden' }}>{this.renderContent()}</Layout.Content>
        {this.renderDrawer()}
      </Layout>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='organization'
        selectedSubMenuStandard='console'
        breadcrumbItemsStandard={[{ title: 'Home', path: '/' }, { title: 'Admin' }, { title: 'Organization' }]}
        breadcrumbItemsModern={[
          { title: 'Home', path: '/' },
          { title: 'Organization', path: '/organization' },
          { title: this.state.activeTab },
        ]}
        pageTitle='Admin'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M10.9556 10.6278L11.2922 10.5037C10.2352 9.98287 8.95914 9.6549 7.50143 9.6549C2.98288 9.6549 0.207764 12.8153 0.207764 15.0158C0.207764 15.8908 0.821556 16.2956 2.12096 16.2956H9.70681C9.67271 16.0809 9.65626 15.8513 9.65626 15.6035V15.2052H1.80101C1.48105 15.2052 1.36352 15.1203 1.36352 14.8852C1.36352 13.3638 3.57711 10.7519 7.50143 10.7519C8.48527 10.7519 9.36152 10.9156 10.1224 11.1848C10.3248 10.9499 10.5998 10.7591 10.9556 10.6278ZM7.51447 8.54489C9.49298 8.54489 11.0862 6.80147 11.0862 4.64009C11.0862 2.51797 9.49298 0.833313 7.51447 0.833313C5.54252 0.833313 3.93624 2.54409 3.93624 4.6532C3.93624 6.80796 5.53596 8.54489 7.51447 8.54489ZM7.51447 7.4544C6.18896 7.4544 5.09198 6.22684 5.09198 4.6532C5.09198 3.12523 6.1824 1.92377 7.51447 1.92377C8.84654 1.92377 9.93047 3.10565 9.93047 4.64009C9.93047 6.21381 8.84005 7.4544 7.51447 7.4544ZM15.5606 11.0258C15.1894 10.8904 14.8482 10.766 14.6384 10.6866C14.3837 10.6018 14.0833 10.5952 13.7961 10.7128C13.6258 10.7763 13.3468 10.8769 13.0318 10.9905C12.4405 11.2037 11.7226 11.4625 11.3605 11.6073C10.8708 11.8032 10.6945 12.0971 10.6945 12.5868V15.6231C10.6945 17.1706 11.5825 17.7387 13.8679 19.0708C14.0573 19.1818 14.3706 19.2144 14.6123 19.0708C16.9042 17.7322 17.7922 17.1706 17.7922 15.6231V12.5868C17.7922 12.0971 17.616 11.8032 17.1262 11.6073C16.7847 11.4723 16.1366 11.2359 15.5606 11.0258ZM13.7112 15.8973L15.768 13.0569C15.8594 12.9263 15.9966 12.8414 16.1728 12.8414C16.4341 12.8414 16.6561 13.0504 16.6561 13.3181C16.6561 13.4095 16.6169 13.514 16.5516 13.6119L14.1356 16.9617C14.0507 17.0727 13.9071 17.1445 13.7308 17.1445C13.6002 17.1445 13.45 17.0857 13.3455 16.9747L11.9416 15.4337C11.8502 15.3357 11.811 15.1921 11.811 15.0811C11.811 14.8069 12.02 14.5979 12.2877 14.5979C12.4575 14.5979 12.5816 14.6828 12.6664 14.7677L13.7112 15.8973Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
}

export const UserCompanyComponentV2 = Form.create<Props>({ name: 'profile_form' })(UserCompany);
